import React from 'react';

function Footer({className}) {
    return (
        <div className={className}>
            <p>© {(new Date().getFullYear())} Copyright kipmate | Designed and built by <a href="https://www.hydracreative.com/" target="_blank" rel="noopener">Hydra Creative</a></p>
        </div>
    );
}


export default Footer;
